import { render, staticRenderFns } from "./Block5Creation.vue?vue&type=template&id=ec23b87c&scoped=true&"
import script from "./Block5Creation.vue?vue&type=script&lang=js&"
export * from "./Block5Creation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec23b87c",
  null
  
)

export default component.exports